/* eslint-disable indent */
import axios from "axios";
import config from "./config.js";
import {
    Loading as loading,
    Message as message
} from "element-ui";
import router from "./router";
import store from "store";
import statecode from './errorCode'

let http, loadingInstance;

let errorCode = statecode.errorCode

//提示弹窗
function tip(type, txt) {
    return message({
        type: type,
        message: txt,
        duration: 1500,
        showClose: true
    });
};

http = axios.create({
    baseURL: config.api,
    timeout: 20000
});

http.interceptors.request.use(function (config) {
    let token = store.get('token');
    if(token){
        config.headers["Authorization"] = token;
    }

    //在这里对请求做修改或者添加，并开启loading
    loadingInstance = loading.service({
        fullScreen: true,
        text: "加载中"
    });
    return config;
}, function (error) {
    return Promise.reject(error);
});

http.interceptors.response.use(function (res) {
    //关闭loading界面,并对提示信息进行统一提醒
    loadingInstance.close();
    return res.data;
}, function (error) {
    //关闭loading界面,并对错误信息统一提醒
    loadingInstance.close();

    let code = error.response.data.code.toString();
    let err = errorCode.filter(item => {
        return item.id === code;
    });
    if(err.length){
        message({
            message: err[0].value,
            type: 'error'
        });
    };
    if(err[0].id === '403'){
        router.push({name:'login'});
    };
    return Promise.reject(error.response.data);
});

export default http;



// WEBPACK FOOTER //
// ./src/http.js